import { useState, useCallback } from "react"
import { APIError } from "../../../../../../app/modules/auth"
import { exportLeadListToCSV } from "../../../../../../mogul/core/_requests"
import { FullCircleFilterObject } from "./FullCircleFilterList"

export const useFullCircleExport = () => {
    const [exporting, setExporting] = useState(false)
    const [errorExporting, setErrorExporting] = useState<string | null>(null)

    const onExportLeadListToCSV = useCallback(
        async (filterObject: FullCircleFilterObject, personSearchFilter?: string) => {
            setExporting(true)
            setErrorExporting(null)
            try {
                await exportLeadListToCSV({
                    type_of_export: 'full_circle',
                    filter: {
                        selected_org_ids: filterObject.selectedOrgIds || [],
                        selected_preneed_options: filterObject.selectedPreneedOptions || [],
                        start_unix_ts: filterObject.startingUnixTimestamp || undefined,
                        end_unix_ts: filterObject.endingUnixTimestamp || undefined,
                        person_search_filter: personSearchFilter || undefined,
                    },
                })
            } catch (exception) {
                console.error(exception)
                const errorMessage =
                    exception instanceof APIError ? exception.message : 'Failed to export leads';
                setErrorExporting(errorMessage)
            } finally {
                setExporting(false)
            }
        },
        []
    )

    return {
        exporting,
        errorExporting,
        onExportLeadListToCSV
    }
}
